import { format, isValid, parse } from 'date-fns';

/**
 * Parses an ISO date-only string in `YYYY-MM-DD` or `YYYY-MM-DD HH:MM:SS` format.
 * Returns `null` when the input is missing or invalid.
 */
export const parseCalendarDate = (value?: string): Date | null => {
  if (!value || !/^\d{4}-\d{2}-\d{2}(?: \d{2}:\d{2}:\d{2})?$/.test(value)) {
    return null;
  }

  const dateString = value.slice(0, 10);
  const parsed = parse(dateString, 'yyyy-MM-dd', new Date());
  return isValid(parsed) ? parsed : null;
};

/**
 * Converts a Date into a local calendar date string in `YYYY-MM-DD` format.
 * Unlike `toISOString()`, this preserves the local calendar day.
 */
export const toCalendarDateString = (value?: Date): string | undefined => {
  if (!value || !isValid(value)) {
    return undefined;
  }

  return format(value, 'yyyy-MM-dd');
};
